<template>
  <div class="home-page info-page">
    <Header></Header>
    <!-- 面包屑导航 -->
    <div class="breadcrumbs">
      <div class="breadcrumbs-content m_section_inner disflex">
        <div class="bd-ul">
          <ul class="">
            <li class="home"><a href="./">{{$t('home')}}</a></li>
            <li><span>{{ currentCanDoName }}</span></li>
          </ul>
        </div>

        <div class="topics_navi">
          <a class="topics_navi_btn" @click="toggleTopicsNav">{{$t('Select_Topics')}}</a>
          <div class="topics_navi_list" :style="{ display: showTopicsNav ? 'block' : 'none' }">
            <div class="disflex flex-between" style="padding:20px 30px">
              <a class="crfb7925 ac" style="font-size: 30px;width: 100%;" @click="toggleTopicsNav">{{$t('Select_Topics')}}</a>
              <div class="crfb7925 fwb" style="font-size: 40px;">x</div>
            </div>
            <ul>
              <li
                v-for="topic in topicsList"
                :key="topic.topic"
                :class="'topic0_bg topic' + topic.topic+'_bg'"
              >
                <a @click="selectTopic(topic)">
                  <div class="topic-number text-shadow" style="background: none;font-size:60px;padding: 0 12px;">
                    {{topic.topic}}
                  </div>
                  <span>
                    <div><strong>{{ topic.title_jp }}</strong></div>
                    <i>{{ topic.title_yin }}</i> / {{ topic.title_en }}
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 页面标题 -->
    <div class="page_title" v-if="currentTopic">
      <div class="m_section_inner" :style="{ background: `linear-gradient(rgba(255,255,255,0.6), rgba(255,255,255,0.6)), url(${currentTopic.cover_image}) no-repeat 0 0 / cover` }">
        <div class="disflex sub-content">
          <div class="disflex topic-header">
            <div class="topic-number text-shadow">
              {{currentTopic.topic}}
            </div>
            <div class="topic-titles">
              <div class="jp">{{currentTopic.title_jp}}</div>
              <div class="jp"><em>{{currentTopic.title_yin}}</em>/{{currentTopic.title_en}}</div>
            </div>
          </div>
          <div class="subtitle">
            <span class="lenson-title">{{ currentCanDoName }}</span>
            <strong>{{ currentCanDoTitle }}</strong>
          </div>
        </div>
      </div>
    </div>

    <!-- Can-do 导航 -->
    <div class="main_contents">
      <section>
        <div class="m_section_inner">
          <nav>
            <a class="cando_navi_btn m_acdtrg noscroll" @click="toggleCanDoNav">
              <span class="open text-shadow">{{$t('Select_Can_do')}}</span>
              <span class="close" :class="showCanDoNav?'block':''"><img src="../../static/images/up.png"></span>
            </a>

            <ul class="cando_navi m_acdsbj" :style="{ display: showCanDoNav ? 'block' : 'none' }">
              <li
                v-for="lesson in currentTopicLessons"
                :key="lesson.lesson_num"

              >
                <div v-for="item in lesson.detail" :key="item.id">
                  <div
                  class="cando_navi_a"
                    @click="selectCanDo(item)"
                    :class="{
                      current: currentLessonId === item.id,
                      speak: item.can_do_name_en.includes('video'),
                      read: item.can_do_name_en.includes('pic'),
                      write: item.can_do_name_en.includes('pic')
                    }"
                  >
                    <div class="number">
                      <span>{{ lesson.lesson_num }}&emsp;{{ lesson.lesson_name }}</span>
                      <strong>
                        {{ item.can_do_name_en }}
                      </strong>
                    </div>
                    <div class="title">{{ item.title_en }}</div>
                  </div>
                </div>
              </li>
            </ul>
          </nav>

          <!-- Step 1: Practice -->
          <h2 class="step1 disflex" v-if="step1Data">
            <div class="step1-num">{{step1Data.lesson_part}}</div>
            <div class="step1-content">
              <strong>{{$t('Practice')}}</strong>
              <span>{{ step1Data.title_en }}</span>
            </div>
          </h2>
          <div id="step1_movie" class="cando_movie" v-if="step1Data">
            <div class="pic_content" v-if="step1Data.lesson_type=='pic'">
              <div v-if="step1Data && step1Data.detail && step1Data.detail.length">
                <img :src="step1Data.detail[currentStep1Video].cover_path" />
              </div>
              <div class="click_nav">
                <div class="click_prev" v-if="currentStep1Video>0" @click="clickNext('prev')">< {{$t('Back')}}</div>
                <div class="click_next" v-if="currentStep1Video+1!=step1Data.detail.length" @click="clickNext('next')">{{$t('Next')}} ></div>
              </div>
            </div>
            <div class="video" v-if="step1Data.lesson_type=='video'">
              <div class="cando_movie_navi">
                <div class="cando_movie_changer">
                  <ul>
                    <li
                      v-for="(item, index) in step1Data.detail"
                      :key="index"
                      :class="{ active: currentStep1Video === index }"
                      @click="changeStep1Video(index)"
                    >
                      <img :src="item.cover_path" :alt="'Step 1 video ' + (index + 1)">
                    </li>
                  </ul>
                </div>
              </div>
              <div class="subtitle_language_selector" v-if="hasSubtitleSource('step1')">
                <button
                  v-for="option in subtitleLanguageOptions"
                  :key="option.value"
                  type="button"
                  class="subtitle_language_button"
                  :class="{ active: getSelectedSubtitleLanguages('step1').includes(option.value) }"
                  @click="toggleSubtitleLanguage('step1', option.value)"
                >
                  {{ $t(option.labelKey) }}
                </button>
              </div>
              <div class="cando_movie_player">
                <video
                  ref="step1VideoPlayer"
                  webkit-playsinline
                  playsinline
                  controls
                  controlslist="nodownload"
                  :poster="step1Data.detail[currentStep1Video].cover_path"
                  @play="onPlay('step1')"
                  @pause="onPause('step1')"
                  @ended="onEnded('step1')"
                  @seeking="onSeeking('step1')"
                  @timeupdate="updateCurrentSubtitleCue('step1')"
                  @ratechange="onRateChange('step1')"
                  @loadedmetadata="onVideoLoaded('step1')"
                  @error="onVideoError('step1')"
                >
                  <source :src="step1Data.detail[currentStep1Video].video_path" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
                <div
                  class="playbutton"
                  :style="{ display: step1VideoPlaying ? 'none' : 'block' }"
                  @click="playVideo('step1')"
                ></div>
                <div class="control"></div>
              </div>
              <div class="video_subtitle_panel" v-if="hasSubtitleSource('step1')">
                <div v-if="getSubtitleBlocks(currentStep1SubtitleCue, 'step1').length">
                  <div
                    v-for="block in getSubtitleBlocks(currentStep1SubtitleCue, 'step1')"
                    :key="block.key"
                    class="subtitle_block"
                  >
                    <span class="subtitle_block_label">{{ block.label }}</span>
                    <p class="subtitle_block_text">{{ block.first }}</p>
                    <p v-if="block.second" class="subtitle_block_text subtitle_block_text_secondary">{{ block.second }}</p>
                  </div>
                </div>
                <p v-else class="subtitle_empty_text">No subtitles at the current moment.</p>
              </div>
            </div>
          </div>

          <a @click="scrollToHash" class="cando_navi_btn text-shadow"><span class="db">{{$t('NEXT_STEP')}}</span><img src="../../static/images/next.png"></a>

          <!-- Step 2: Hiragana -->
          <h2 id="step2" class="step2 disflex" v-if="step2Data">
            <div class="step1-num">{{step2Data.lesson_part}}</div>
            <div class="step1-content">
              <strong>{{$t('Challenge')}}</strong>
              <span>{{ step2Data.title_en }}</span>
            </div>
          </h2>
          <div id="step2_movie" class="cando_movie" v-if="step2Data">
            <div class="pic_content" v-if="step2Data.lesson_type=='pic'">
              <div v-if="step2Data && step2Data.detail && step2Data.detail.length">
                <img :src="step2Data.detail[currentStep1Video].cover_path" />
              </div>

              <div class="click_nav">
                <div class="click_prev" @click="clickNext('prev')">< back</div>
                <div class="click_next" @click="clickNext('next')">next ></div>
              </div>
            </div>
            <div class="video" v-if="step2Data.lesson_type=='video'">
              <div class="subtitle_language_selector" v-if="hasSubtitleSource('step2')">
                <button
                  v-for="option in subtitleLanguageOptions"
                  :key="option.value"
                  type="button"
                  class="subtitle_language_button"
                  :class="{ active: getSelectedSubtitleLanguages('step2').includes(option.value) }"
                  @click="toggleSubtitleLanguage('step2', option.value)"
                >
                  {{ $t(option.labelKey) }}
                </button>
              </div>
              <div class="cando_movie_player Hiragana">
                <video
                  ref="step2VideoPlayer"
                  webkit-playsinline
                  playsinline
                  controls
                  controlslist="nodownload"
                  :poster="step2Data.detail[0].cover_path"
                  @play="onPlay('step2')"
                  @pause="onPause('step2')"
                  @ended="onEnded('step2')"
                  @seeking="onSeeking('step2')"
                  @timeupdate="updateCurrentSubtitleCue('step2')"
                  @ratechange="onRateChange('step2')"
                  @loadedmetadata="onVideoLoaded('step2')"
                  @error="onVideoError('step2')"
                >
                  <source :src="step2Data.detail[0].video_path" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
                <div
                  class="playbutton"
                  :style="{ display: step2VideoPlaying ? 'none' : 'block' }"
                  @click="playVideo('step2')"
                ></div>
                <div class="control"></div>
              </div>
              <div class="video_subtitle_panel" v-if="hasSubtitleSource('step2')">
                <div v-if="getSubtitleBlocks(currentStep2SubtitleCue, 'step2').length">
                  <div
                    v-for="block in getSubtitleBlocks(currentStep2SubtitleCue, 'step2')"
                    :key="block.key"
                    class="subtitle_block"
                  >
                    <span class="subtitle_block_label">{{ block.label }}</span>
                    <p class="subtitle_block_text">{{ block.first }}</p>
                    <p v-if="block.second" class="subtitle_block_text subtitle_block_text_secondary">{{ block.second }}</p>
                  </div>
                </div>
                <p v-else class="subtitle_empty_text">No subtitles at the current moment.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
import md5 from '../../static/js/md5.min.js'

export default {
  components: {
    Header,Dialog
  },
  data() {
    return {
      info: {},
      id: '',
      startTime: 0,
      totalWatchTime: 0,
      reportingInterval: null,
      currentStep1Video: 0,
      step1Data: {},
      step2Data: {},
      topicsList: [],
      currentTopic: null,
      currentLessonId: null,
      currentCanDoName: '',
      currentCanDoTitle: '',
      showTopicsNav: false,
      showCanDoNav: false,
      step1VideoPlaying: false,
      step2VideoPlaying: false,
      step1VideoReady: false,
      step2VideoReady: false,
      subtitleLanguageOptions: [
        { labelKey: 'Japanese', value: 'ja' },
        { labelKey: 'Roma_ji', value: 'ro' },
        { labelKey: 'English', value: 'en' },
        { labelKey: 'Myanmar', value: 'my' }
      ],
      step1SelectedSubtitleLanguages: ['ja', 'ro', 'en', 'my'],
      step2SelectedSubtitleLanguages: ['ja', 'ro', 'en', 'my'],
      subtitleCache: {},
      step1Subtitles: [],
      step2Subtitles: [],
      currentStep1SubtitleCue: null,
      currentStep2SubtitleCue: null
    }
  },
  computed: {
    currentTopicLessons() {
      return this.currentTopic ? this.currentTopic.lesson : [];
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    this.getTopicsList();
  },
  beforeDestroy() {
    // Clean up event listeners
    clearInterval(this.reportingInterval);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  watch: {
    '$route'(to, from) {
      if (to.query.id !== from.query.id) {
        this.id = to.query.id;
        this.getList();
        this.updateCurrentCanDoInfo();
      }
    },
    currentStep1Video() {
      // Reset video state when changing video
      this.step1VideoPlaying = false;
      this.step1VideoReady = false;
      this.loadStepSubtitles('step1');
    }
  },
  beforeRouteLeave(to, from, next) {
    // Pause all video players when leaving
    this.pauseAllVideos();
    next();  // Continue navigation
  },
  created(){
    this.id = this.$route.query.id
    this.getList()
    // this.updateCurrentCanDoInfo();
  },
  methods: {
    back(){
      this.$router.push({path:'/'});
    },

    // 播放视频
    playVideo(videoType) {
      const videoPlayer = videoType === 'step1'
        ? this.$refs.step1VideoPlayer
        : this.$refs.step2VideoPlayer;

      if (videoPlayer) {
        videoPlayer.play().then(() => {
          console.log(`${videoType} video started playing`);
        }).catch(error => {
          console.error(`Error playing ${videoType} video:`, error);
          // 显示错误信息
          // alert(`无法播放视频: ${error.message}`);
        });
      }
    },

    sanitizeMediaUrl(url) {
      if (!url) return '';
      return String(url)
        .trim()
        .replace(/^`+|`+$/g, '')
        .replace(/^"+|"+$/g, '')
        .replace(/^'+|'+$/g, '')
        .trim();
    },

    normalizeLessonData(data) {
      if (!data || !Array.isArray(data.detail)) {
        return data || {};
      }

      return {
        ...data,
        detail: data.detail.map(section => ({
          ...section,
          detail: Array.isArray(section.detail)
            ? section.detail.map(item => ({
              ...item,
              cover_path: this.sanitizeMediaUrl(item.cover_path),
              video_path: this.sanitizeMediaUrl(item.video_path),
              subtitle_path: this.sanitizeMediaUrl(item.subtitle_path)
            }))
            : []
        }))
      };
    },

    getCurrentVideoDetail(videoType) {
      const stepData = videoType === 'step1' ? this.step1Data : this.step2Data;
      if (!stepData || !Array.isArray(stepData.detail) || !stepData.detail.length) {
        return null;
      }

      const currentIndex = videoType === 'step1' ? this.currentStep1Video : 0;
      return stepData.detail[currentIndex] || null;
    },

    hasSubtitleSource(videoType) {
      const currentDetail = this.getCurrentVideoDetail(videoType);
      return !!(currentDetail && currentDetail.subtitle_path);
    },

    getSelectedSubtitleLanguages(videoType) {
      return videoType === 'step1'
        ? this.step1SelectedSubtitleLanguages
        : this.step2SelectedSubtitleLanguages;
    },

    toggleSubtitleLanguage(videoType, language) {
      const selectedLanguages = this.getSelectedSubtitleLanguages(videoType);
      const currentIndex = selectedLanguages.indexOf(language);
      if (currentIndex > -1) {
        selectedLanguages.splice(currentIndex, 1);
      } else {
        selectedLanguages.push(language);
      }
    },

    async fetchSubtitleData(subtitlePath) {
      if (!subtitlePath) {
        return [];
      }

      if (this.subtitleCache[subtitlePath]) {
        return this.subtitleCache[subtitlePath];
      }

      try {
        const response = await fetch(subtitlePath);
        if (!response.ok) {
          throw new Error(`Failed to load subtitles: ${response.status}`);
        }

        const subtitleJson = await response.json();
        const cues = Array.isArray(subtitleJson.cues) ? subtitleJson.cues : [];
        this.$set(this.subtitleCache, subtitlePath, cues);
        return cues;
      } catch (error) {
        console.error('Subtitle loading failed:', error);
        this.$set(this.subtitleCache, subtitlePath, []);
        return [];
      }
    },

    async loadStepSubtitles(videoType) {
      const currentDetail = this.getCurrentVideoDetail(videoType);
      const subtitlePath = currentDetail ? currentDetail.subtitle_path : '';

      if (!subtitlePath) {
        if (videoType === 'step1') {
          this.step1Subtitles = [];
          this.currentStep1SubtitleCue = null;
        } else {
          this.step2Subtitles = [];
          this.currentStep2SubtitleCue = null;
        }
        return;
      }

      const subtitles = await this.fetchSubtitleData(subtitlePath);
      const latestDetail = this.getCurrentVideoDetail(videoType);
      const latestSubtitlePath = latestDetail ? latestDetail.subtitle_path : '';
      if (subtitlePath !== latestSubtitlePath) {
        return;
      }

      if (videoType === 'step1') {
        this.step1Subtitles = subtitles;
      } else {
        this.step2Subtitles = subtitles;
      }
      this.updateCurrentSubtitleCue(videoType);
    },

    getCueTime(cue) {
      const time = parseFloat(cue && cue.time);
      return Number.isFinite(time) ? time : 0;
    },

    findCurrentCue(cues, currentTime) {
      if (!Array.isArray(cues) || !cues.length) {
        return null;
      }

      for (let index = 0; index < cues.length; index++) {
        const currentCue = cues[index];
        const startTime = this.getCueTime(currentCue);
        const nextCue = cues[index + 1];
        const nextTime = nextCue ? this.getCueTime(nextCue) : Number.POSITIVE_INFINITY;

        if (currentTime >= startTime && currentTime < nextTime) {
          return currentCue;
        }
      }

      return cues[cues.length - 1] || null;
    },

    updateCurrentSubtitleCue(videoType) {
      const videoPlayer = videoType === 'step1'
        ? this.$refs.step1VideoPlayer
        : this.$refs.step2VideoPlayer;
      const currentTime = videoPlayer && !Number.isNaN(videoPlayer.currentTime)
        ? videoPlayer.currentTime
        : 0;
      const subtitleList = videoType === 'step1' ? this.step1Subtitles : this.step2Subtitles;
      const currentCue = this.findCurrentCue(subtitleList, currentTime);

      if (videoType === 'step1') {
        this.currentStep1SubtitleCue = currentCue;
      } else {
        this.currentStep2SubtitleCue = currentCue;
      }
    },

    getSubtitleBlocks(cue, videoType) {
      const selectedLanguages = this.getSelectedSubtitleLanguages(videoType);
      if (!cue || !selectedLanguages.length) {
        return [];
      }

      return this.subtitleLanguageOptions
        .filter(option => selectedLanguages.includes(option.value))
        .map(option => {
        const language = option.value;
        const subtitleContent = cue[language] || {};
        const firstLine = subtitleContent.first ? String(subtitleContent.first).trim() : '';
        const secondLine = subtitleContent.second ? String(subtitleContent.second).trim() : '';
        const personPrefix = cue.person && cue.person !== 'm' ? `${cue.person}: ` : '';
        const displayFirstLine = firstLine ? `${personPrefix}${firstLine}` : '-';

        return {
          key: language,
          label: option.labelKey ? this.$t(option.labelKey) : language,
          first: displayFirstLine,
          second: secondLine
        };
      });
    },

    // 暂停所有视频
    pauseAllVideos() {
      const step1VideoPlayer = this.$refs.step1VideoPlayer;
      const step2VideoPlayer = this.$refs.step2VideoPlayer;

      if (step1VideoPlayer) {
        step1VideoPlayer.pause();
        step1VideoPlayer.currentTime = 0;
      }

      if (step2VideoPlayer) {
        step2VideoPlayer.pause();
        step2VideoPlayer.currentTime = 0;
      }
    },

    // 获取主题列表
    getTopicsList() {
      let that = this;
      that.$api.post('/api/activity/list', {}, r => {
        that.$parent.returnCode(r, function(){
          that.topicsList = r.data;

          // 根据当前id匹配对应的主题
          if (that.topicsList.length > 0) {
            // 查找包含当前id的主题
            const matchedTopic = that.findTopicById(that.topicsList, that.id);
            if (matchedTopic) {
              that.currentTopic = matchedTopic;
            } else if (!that.currentTopic) {
              // 如果没有匹配到，默认选择第一个主题
              that.currentTopic = that.topicsList[0];
            }
          }
          // 更新当前Can-do信息
          that.updateCurrentCanDoInfo();
        })
      })
    },

    // 新增方法：根据id查找对应的主题
    findTopicById(topicsList, id) {
      if (!id) return null;

      for (let topic of topicsList) {
        // 遍历主题下的所有lesson和detail
        for (let lesson of topic.lesson) {
          for (let item of lesson.detail) {
            if (item.id == id) {
              return topic;
            }
          }
        }
      }
      return null;
    },
    scrollToHash() {
      const element = document.getElementById('step2');
      if (element) {
        // 计算元素位置并添加140px偏移
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });

        // 备用方案：使用scrollIntoView with offset
        // const yOffset = -150;
        // const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        // window.scrollTo({top: y, behavior: 'smooth'});
      }
    },
    // 切换主题导航显示
    toggleTopicsNav() {
      this.showTopicsNav = !this.showTopicsNav;
    },

    // 切换Can-do导航显示
    toggleCanDoNav() {
      this.showCanDoNav = !this.showCanDoNav;
    },

    // 选择主题
    selectTopic(topic) {
      this.currentTopic = topic;
      this.showTopicsNav = false;
      // 可以选择默认显示第一个can-do
      if (topic.lesson.length > 0 && topic.lesson[0].detail.length > 0) {
        this.selectCanDo(topic.lesson[0].detail[0]);
      }
    },

    // 选择Can-do
    selectCanDo(item) {
      if (this.$route.query.id == item.id) {
        return;
      }
      this.currentLessonId = item.id;
      this.currentCanDoName = item.can_do_name_en;
      this.currentCanDoTitle = item.title_en;
      this.showCanDoNav = false;

      // 清空当前信息并跳转
      this.info = {};
      this.step1Data = {};
      this.step2Data =  {};
      this.step1Subtitles = [];
      this.step2Subtitles = [];
      this.currentStep1SubtitleCue = null;
      this.currentStep2SubtitleCue = null;
      this.pauseAllVideos();

      this.$nextTick(() => {
        this.$router.push({path:'/CommunicationActivities',query: {id:item.id}});
        this.id = item.id;
        this.getList();
      });
    },

    // 更新当前Can-do信息
    updateCurrentCanDoInfo() {
      if (!this.currentTopic || !this.$route.query.id) return;

      for (let lesson of this.currentTopic.lesson) {
        for (let item of lesson.detail) {
          console.log(item.id)
          if (item.id == this.id) {
            this.currentLessonId = item.id;
            this.currentCanDoName = item.can_do_name_en;
            this.currentCanDoTitle = item.title_en;
            return;
          }
        }
      }
    },
    clickNext(type){
      if(type=='next'){
        if(this.currentStep1Vide+1==this.step1Data.detail.length){
          return;
        }
        this.currentStep1Video++;
      }else{
        if(this.currentStep1Vide==0){
          return;
        }
        this.currentStep1Video--;
      }
    },
    changeStep1Video(index) {
      this.currentStep1Video = index;
      this.step1VideoPlaying = false;
      this.step1VideoReady = false;

      // Reset video player to load new video
      this.$nextTick(() => {
        const videoPlayer = this.$refs.step1VideoPlayer;
        if (videoPlayer) {
          videoPlayer.load();
          // 预加载视频
          videoPlayer.preload = "auto";
        }
      });
    },

    getList(){
      let that = this
      let data = {
        "id": this.id
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/activity/detail', data, r =>{
        that.$parent.returnCode(r, function(){
          const normalizedData = that.normalizeLessonData(r.data);
          that.info = normalizedData
          that.currentStep1Video = 0;
          that.step1Subtitles = [];
          that.step2Subtitles = [];
          that.currentStep1SubtitleCue = null;
          that.currentStep2SubtitleCue = null;

          // Separate step1 and step2 data
          that.step1Data = normalizedData.detail.find(item => item.lesson_part === 'step1');
          that.step2Data = normalizedData.detail.find(item => item.lesson_part === 'step2');

          that.$parent.loadModal(false);

          // 确保主题正确设置
          if (that.topicsList.length > 0 && !that.currentTopic) {
            const matchedTopic = that.findTopicById(that.topicsList, that.id);
            that.currentTopic = matchedTopic || that.topicsList[0];
          }



          // 预加载视频
          that.$nextTick(() => {
            that.preloadVideos();
            that.loadStepSubtitles('step1');
            that.loadStepSubtitles('step2');
          });
        })
      })
    },

    // 预加载视频
    preloadVideos() {
      const step1VideoPlayer = this.$refs.step1VideoPlayer;
      const step2VideoPlayer = this.$refs.step2VideoPlayer;

      if (step1VideoPlayer) {
        step1VideoPlayer.preload = "auto";
        step1VideoPlayer.load();
      }

      if (step2VideoPlayer) {
        step2VideoPlayer.preload = "auto";
        step2VideoPlayer.load();
      }
    },

    // 视频事件处理
    onVideoLoaded(videoType) {
      console.log(`${videoType} video loaded`);
      if (videoType === 'step1') {
        this.step1VideoReady = true;
      } else {
        this.step2VideoReady = true;
      }
      this.updateCurrentSubtitleCue(videoType);
    },

    onVideoError(videoType) {
      console.error(`${videoType} video error`);
      const videoPlayer = videoType === 'step1'
        ? this.$refs.step1VideoPlayer
        : this.$refs.step2VideoPlayer;

      if (videoPlayer) {
        console.error('Video error details:', videoPlayer.error);
      }
    },

    reportWatchTime(force = false, finished = false, videoType = 'step1') {
      return;
      const now = Date.now();
      let currentWatch = (now - this.startTime) / 1000;
      this.totalWatchTime += currentWatch;
      this.startTime = now;

      // Don't report if watch time is less than 5 seconds (unless forced)
      if (!force && currentWatch < 5) return;

      let that = this
      let ts = Date.now();
      let seconds = Math.round(this.totalWatchTime);
      let sign = that.generateSign(seconds, ts);
      let data = {
        video_id: this.id,
        seconds: seconds,
        finished: finished,
        video_type: videoType,
        ts: ts,
        sign: sign
      }
      that.$api.post('/api/watch/report_time', data, r =>{
        that.$parent.returnCode(r, function(){
          // Handle response if needed
        })
      })
    },

    generateSign(score, ts, secret = "jksdfuiAa4so") {
      const str = String(score) + String(ts) + secret
      return md5(str);
    },

    // Check if we should count time (tab visible, playing normally at 1x speed)
    canCountTime(videoType) {
      const videoElement = videoType === 'step1'
        ? this.$refs.step1VideoPlayer
        : this.$refs.step2VideoPlayer;

      return videoElement &&
             !document.hidden &&
             !videoElement.paused &&
             videoElement.playbackRate === 1.0;
    },

    // Start the reporting interval
    startReporting(videoType) {
      this.startTime = Date.now();
      if (this.reportingInterval) clearInterval(this.reportingInterval);

      this.reportingInterval = setInterval(() => {
        if (this.canCountTime(videoType)) {
          this.reportWatchTime(false, false, videoType);
        }
      }, 10000); // Report every 10 seconds
    },

    // Event handlers
    onPlay(videoType) {
      console.log(`${videoType} 开始播放`);
      if (videoType === 'step1') {
        this.step1VideoPlaying = true;
        this.videoElement = this.$refs.step1VideoPlayer;
      } else {
        this.step2VideoPlaying = true;
        this.videoElement = this.$refs.step2VideoPlayer;
      }

      if (!this.videoElement) return;
      if (this.videoElement.playbackRate !== 1.0) {
        this.videoElement.pause();
        return;
      }
      this.startReporting(videoType);
    },

    onPause(videoType) {
      console.log(`${videoType} 暂停播放`);
      if (videoType === 'step1') {
        this.step1VideoPlaying = false;
      } else {
        this.step2VideoPlaying = false;
      }

      if (this.canCountTime(videoType)) {
        this.reportWatchTime(false, false, videoType);
      }
      clearInterval(this.reportingInterval);
    },

    onEnded(videoType) {
      console.log(`${videoType} 播放结束`);
      if (videoType === 'step1') {
        this.step1VideoPlaying = false;
      } else {
        this.step2VideoPlaying = false;
      }

      this.reportWatchTime(true, true, videoType); // Force report and mark as finished
      this.updateCurrentSubtitleCue(videoType);
      clearInterval(this.reportingInterval);
    },

    onSeeking(videoType) {
      console.log(`${videoType} 拖动进度条`);
      // Reset timer when seeking to prevent cheating
      this.startTime = Date.now();
      this.updateCurrentSubtitleCue(videoType);
    },

    onRateChange(videoType) {
      console.log(`${videoType} 倍速播放`);
      if (videoType === 'step1') {
        this.videoElement = this.$refs.step1VideoPlayer;
      } else {
        this.videoElement = this.$refs.step2VideoPlayer;
      }

      if (this.videoElement && this.videoElement.playbackRate !== 1.0) {
        this.videoElement.pause();
      }
    },

    handleVisibilityChange() {
      // Check both video players
      const step1VideoPlayer = this.$refs.step1VideoPlayer;
      const step2VideoPlayer = this.$refs.step2VideoPlayer;

      if (document.hidden) {
        // Report time for any playing video
        if (step1VideoPlayer && !step1VideoPlayer.paused) {
          this.reportWatchTime(true, false, 'step1');
        }
        if (step2VideoPlayer && !step2VideoPlayer.paused) {
          this.reportWatchTime(true, false, 'step2');
        }

        clearInterval(this.reportingInterval);
      } else {
        // Restart reporting for any playing video
        if (step1VideoPlayer && !step1VideoPlayer.paused) {
          this.startReporting('step1');
        } else if (step2VideoPlayer && !step2VideoPlayer.paused) {
          this.startReporting('step2');
        }
      }
    },

    handleBeforeUnload() {
      // Report time for any playing video before page unload
      const step1VideoPlayer = this.$refs.step1VideoPlayer;
      const step2VideoPlayer = this.$refs.step2VideoPlayer;

      if (step1VideoPlayer && !step1VideoPlayer.paused) {
        this.reportWatchTime(true, false, 'step1');
      }
      if (step2VideoPlayer && !step2VideoPlayer.paused) {
        this.reportWatchTime(true, false, 'step2');
      }
    }
  }
}
</script>

<style scoped>
  .step1-num{background: #2c3e5e;color:#fff;border-radius: 100px;height: 100px;width:100px;line-height: 100px;font-size:28px;text-align: center;font-weight: 800;margin-right: 20px;}
  .step1-content{width: calc(100% - 140px);}


  /* 响应式调整 */
  @media (max-width: 768px) {
    .cando_movie_player video {
      min-height: 250px;
    }

  }
.page_title h2 i {
  font-style: italic;

  opacity: 0.9;
}


.main_contents {
  padding: 20px;
}

/* Can-do导航样式 */
.cando_navi_btn .close.block img{transform: rotate(182deg);}

.cando_navi {
  list-style: none;
  padding: 0;
  margin: 0 0 30px 0;
}
.cando_navi .cando_navi_a{background: #ffd9a1;padding:15px;margin: 0 0 10px;border-radius: 10px;display: flex;align-items: center;}
.cando_navi .cando_navi_a.current{background: #ffa31c;}
.cando_navi_a .number{width: 30%;border-right: 5px solid #fcf5ed;}
.cando_navi_a span{font-size:22px;line-height: 20px;display: inline-block;}
.cando_navi_a strong{display: block;    font-size: 30px;}
.cando_navi_a .title{margin:0 20px;width:70%}
/* Step headers */
.step1, .step2 {
  margin: 40px 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #2c3e5e;
}

.step1 strong, .step2 strong {
  display: block;
  font-size: 34px;
  color: #2c3e5e;
}

.step1 span, .step2 span {
  font-size: 20px;
  color: #666;
  display:block;
}

/* Video player styles */
.cando_movie {
  margin:0 0px 40px;
}

.cando_movie_navi {
  margin-bottom: 15px;
}

.cando_movie_changer ul {
  display: flex;
  gap: 10px;
  list-style: none;
  padding: 0;
  margin: 0;
  overflow-x: auto;
}

.cando_movie_changer li {
  flex-shrink: 0;
  cursor: pointer;
  border: 4px solid transparent;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.3s;
  position: relative;
}

.cando_movie_changer li.active {
  border-color: #2c3e5e;
}
.cando_movie_changer li::after{background: url(../../static/images/icon_play.png) no-repeat center center;content:'';position: absolute;width: 100%;
    height: 100%;
    top: 0;
    left:0;}
.cando_movie_changer li.active::after{display: none;}
.cando_movie_changer li img {
  width: 100%;
  height: 120px;
  display: block;
}

.cando_movie_player {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.cando_movie_player video {
  width: 100%;
  height: auto;
  display: block;
}

.cando_movie_player.Hiragana {
  max-width: 800px;
  margin: 0 auto;
}

.subtitle_language_selector {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin: 0 0 18px;
}

.subtitle_language_button {
  border: 1px solid #d7dce5;
  background: #fff;
  color: #2c3e5e;
  border-radius: 999px;
  min-width: 136px;
  min-height: 52px;
  padding: 12px 22px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.subtitle_language_button.active {
  border-color: #2c3e5e;
  background: #2c3e5e;
  color: #fff;
}

.video_subtitle_panel {
  margin-top: 18px;
  padding: 22px 24px;
  background: #f5f7fb;
  border: 1px solid #dbe3ef;
  border-radius: 12px;
}

.subtitle_block + .subtitle_block {
  margin-top: 18px;
}

.subtitle_block_label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 88px;
  margin-bottom: 10px;
  padding: 4px 12px;
  border-radius: 999px;
  background: #e0e8f5;
  color: #2c3e5e;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
}

.subtitle_block_text {
  margin: 0;
  color: #2c3e5e;
  font-size: 28px;
  line-height: 1.75;
}

.subtitle_block_text_secondary {
  margin-top: 4px;
}

.subtitle_empty_text {
  margin: 0;
  color: #7b8798;
  font-size: 18px;
}


/* Responsive adjustments */
@media (max-width: 768px) {
  .main_contents {
    padding: 10px;
  }

  .page_title h2 {
    flex-direction: column;
    text-align: center;
  }

  .page_title h2 span {
    text-align: center;
  }

  .topics_navi_list {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
  }

  .subtitle_language_selector {
    gap: 10px;
  }

  .subtitle_language_button {
    min-width: 112px;
    min-height: 44px;
    font-size: 15px;
    padding: 10px 16px;
  }

  .video_subtitle_panel {
    padding: 16px;
  }

  .subtitle_block_text {
    font-size: 21px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/CommunicationActivities.vue